import React, { useState, useEffect } from "react";
import { Modal, Form, Button } from "react-bootstrap";
import NotifyData from "../../components/NotifyData";
import { useDispatch, useSelector } from "react-redux";
import {
  addCategory,
  updateCategory,
  clearError,
} from "../../slice/ExpenseCategorySlice";

const Category = ({ show, handleClose, editCategory }) => {
  const dispatch = useDispatch();
  const { error, status } = useSelector((state) => state.categories);
  const isEditMode = !!editCategory;

  const [formData, setFormData] = useState({
    category_name: "",
  });
  const [loading, setLoading] = useState(false);
  const [validationError, setValidationError] = useState(null);

  useEffect(() => {
    if (show) {
      if (isEditMode) {
        setFormData({
          category_name: editCategory.category_name || "",
        });
      } else {
        setFormData({ category_name: "" });
      }
      setValidationError(null);
    }
  }, [show, editCategory, isEditMode]);

  const handleChange = (e) => {
    const value = e.target.value;
    setFormData({ category_name: value });

    // const regex = /^[a-zA-Z0-9., ]+$/;
    // if (value && !regex.test(value)) {
    //   setValidationError(
    //     "Category Name must be alphanumeric and can include spaces, dots, and commas"
    //   );
    // } else {
    //   setValidationError(null);
    // }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    // Check for validation error before submitting
    if (validationError) {
      NotifyData(validationError, "error");
      setLoading(false);
      return;
    }

    try {
      if (isEditMode) {
        await dispatch(
          updateCategory({
            category_id: editCategory.category_id,
            category_name: formData.category_name,
          }),
        ).unwrap();
        NotifyData("Category Updated Successfully", "success");
      } else {
        await dispatch(
          addCategory({ category_name: formData.category_name }),
        ).unwrap();
        NotifyData("Category Created Successfully", "success");
      }
      handleClose(true); // Signal success to parent
    } catch (err) {
      // Error is already handled by the useEffect hook
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={() => handleClose(false)} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {isEditMode ? "Edit Category" : "Add Category"}
        </Modal.Title>
      </Modal.Header>
      <Form onSubmit={handleSubmit}>
        <Modal.Body>
          <Form.Group>
            <Form.Label>Category Name</Form.Label>
            <Form.Control
              type="text"
              name="category_name"
              value={formData.category_name}
              onChange={handleChange}
              placeholder="Enter category name"
              required
              disabled={loading}
              isInvalid={!!validationError}
            />
            <Form.Control.Feedback type="invalid">
              {validationError}
            </Form.Control.Feedback>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => handleClose(false)}
            disabled={loading}
          >
            Cancel
          </Button>
          <Button variant="success" type="submit" disabled={loading}>
            {loading
              ? isEditMode
                ? "Updating..."
                : "Submitting..."
              : isEditMode
                ? "Update"
                : "Create"}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default Category;
